import api from "../api";

export async function getApprovalsInbox() {
    const res = await api.get("/epo-approvals/inbox");
    return res.data;
}

export async function getEpoApprovalHistory(epoNum) {
    const res = await api.get(`/epo-approvals/${epoNum}/history`);
    return res.data;
}

export async function getEpoApprovalCurrent(epoNum) {
    const res = await api.get(`/epo-approvals/${epoNum}/current`);
    return res.data;
}

export async function submitEpo(epoNum) {
    const res = await api.post(`/epo/${epoNum}/submit`);
    return res.data;
}

export async function approveEpo(epoNum, comment) {
    await api.post(`/epo/${epoNum}/approve`, { comment });
}

export async function rejectEpo(epoNum, comment) {
    await api.post(`/epo/${epoNum}/reject`, { comment });
}

// Round 15 — creator-cancel for a PENDING EPO. Comment is optional.
export async function cancelEpo(epoNum, comment) {
    await api.post(`/epo/${epoNum}/cancel`, { comment });
}
